import axios from 'axios'

const API_URL = process.env.REACT_APP_BASE_API_URL
const GET_SHAREHOLDERS = `${API_URL}/stakeholders/shareholders`
const CREATE_DOCUMENT = `${API_URL}/stakeholders/documents`
const SECURITY_CLASSES = `${API_URL}/stakeholders/security-classes`
const SHAREHOLDER_TRANSACTIONS = `${API_URL}/stakeholders/shareholder`

export const createDocument = (
  fileIds: number[],
  stakeholderModuleType: string,
  stakeholderModuleId: string,
  companyId: number
) => {
  return axios.post(
    CREATE_DOCUMENT,
    {
      fileIds,
      stakeholderModuleType,
      stakeholderModuleId,
    },
    {
      headers: {
        'x-company-id': companyId,
      },
      validateStatus(status) {
        return true
      },
    }
  )
}

export const deleteDocument = (documentId: number, companyId: number) => {
  return axios.delete(`${CREATE_DOCUMENT}/${documentId}`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status) {
      return true
    },
  })
}

export const getShareholders = (
  companyId: number,
  page: number,
  pageSize: number,
  type?: string,
  sortBy?: string,
  all?: string,
  shareholderId?: string
) => {
  return axios.get(
    `${GET_SHAREHOLDERS}?page=${page}&pageSize=${pageSize}${type ? `&type=${type}` : ''}${
      sortBy ? `&sortBy=${sortBy}` : ''
    }${all ? `&all=${all}` : ''}${shareholderId ? `&shareholderId=${shareholderId}` : ''}`,
    {
      headers: {
        'x-company-id': companyId,
      },
      validateStatus(status) {
        return true
      },
    }
  )
}

export const createShareholder = (payload: any, companyId: number) => {
  return axios.post(`${GET_SHAREHOLDERS}`, payload, {
    headers: {
      'x-company-id': companyId.toString(),
    },
    validateStatus(status) {
      return true
    },
  })
}

export const getSharholderDetails = (shareholderId: string, companyId: number) => {
  return axios.get(`${GET_SHAREHOLDERS}/${shareholderId}`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status) {
      return true
    },
  })
}

export const updateShareholder = (payload: any, companyId: number, shareholderId: string) => {
  return axios.post(`${GET_SHAREHOLDERS}/${shareholderId}`, payload, {
    headers: {
      'x-company-id': companyId.toString(),
    },
    validateStatus(status) {
      return true
    },
  })
}

export const deleteShareholder = (shareholderId: string, companyId: number) => {
  return axios.delete(`${GET_SHAREHOLDERS}/${shareholderId}`, {
    headers: {
      'x-company-id': companyId.toString(),
    },
    validateStatus(status) {
      return true
    },
  })
}

export const getShareholdersDashboardCounts = (companyId: number) => {
  return axios.get(`${GET_SHAREHOLDERS}/statistics`, {
    headers: {
      'x-company-id': companyId,
    },
  })
}

export const createOrUpdateBankDetails = (
  payload: any,
  companyId: number,
  shareholderId: string,
  bankDetailId?: string
) => {
  return axios.post(
    `${GET_SHAREHOLDERS}/${shareholderId}/bank-details${
      bankDetailId ? `?bankDetailId=${bankDetailId}` : ''
    }`,
    payload,
    {
      headers: {
        'x-company-id': companyId.toString(),
      },
      validateStatus(status) {
        return true
      },
    }
  )
}

export const getSharholderBankDetails = (
  shareholderId: string,
  companyId: number,
  bankDetailId: string
) => {
  return axios.get(`${GET_SHAREHOLDERS}/${shareholderId}/bank-details/${bankDetailId}`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status) {
      return true
    },
  })
}

export const getShareSecurityClasses = (
  companyId: number,
  page: number,
  pageSize: number,
  sortBy?: string,
  all?: string,
  buyback?: string
) => {
  return axios.get(
    `${SECURITY_CLASSES}/shares?page=${page}&pageSize=${pageSize}${
      sortBy ? `&sortBy=${sortBy}` : ''
    }${all ? `&all=${all}` : ''}${buyback ? `&buyback=${buyback}` : ''}`,
    {
      headers: {
        'x-company-id': companyId,
      },
      validateStatus(status) {
        return true
      },
    }
  )
}

export const createShareSecurityClass = (payload: any, companyId: number) => {
  return axios.post(`${SECURITY_CLASSES}/shares`, payload, {
    headers: {
      'x-company-id': companyId.toString(),
    },
    validateStatus(status) {
      return true
    },
  })
}

export const updateShareSecurityClass = (
  payload: any,
  companyId: number,
  securityClassId: string
) => {
  return axios.post(`${SECURITY_CLASSES}/shares/${securityClassId}`, payload, {
    headers: {
      'x-company-id': companyId.toString(),
    },
    validateStatus(status) {
      return true
    },
  })
}

export const getShareSecurityClassById = (companyId: number, shareClassId: string) => {
  return axios.get(`${SECURITY_CLASSES}/shares/${shareClassId}`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status) {
      return true
    },
  })
}

export const exportShareSecurityClasses = (companyId: number) => {
  return axios.get(`${SECURITY_CLASSES}/shares/csv/export`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status) {
      return true
    },
  })
}

export const deleteShareSecurityClass = (companyId: number, securityClassId: string) => {
  return axios.delete(`${SECURITY_CLASSES}/shares/${securityClassId}`, {
    headers: {
      'x-company-id': companyId.toString(),
    },
    validateStatus(status) {
      return true
    },
  })
}

export const deleteShareConvertibleClass = (companyId: number, convertibleClassId: string) => {
  return axios.delete(`${SECURITY_CLASSES}/convertibles/${convertibleClassId}`, {
    headers: {
      'x-company-id': companyId.toString(),
    },
    validateStatus(status) {
      return true
    },
  })
}

export const getConvertibleSecurityClasses = (
  companyId: number,
  page: number,
  pageSize: number,
  sortBy?: string,
  rate?: string,
  all?: string
) => {
  return axios.get(
    `${SECURITY_CLASSES}/convertibles?page=${page}&pageSize=${pageSize}${
      sortBy ? `&sortBy=${sortBy}` : ''
    }${rate ? `&rate=${rate}` : ''}${all ? `&all=${all}` : ''}`,
    {
      headers: {
        'x-company-id': companyId,
      },
      validateStatus(status) {
        return true
      },
    }
  )
}

export const createConvertibleSecurityClass = (payload: any, companyId: number) => {
  return axios.post(`${SECURITY_CLASSES}/convertibles`, payload, {
    headers: {
      'x-company-id': companyId.toString(),
    },
    validateStatus(status) {
      return true
    },
  })
}

export const updateConvertibleSecurityClass = (
  payload: any,
  companyId: number,
  convertibleClassId: string
) => {
  return axios.post(`${SECURITY_CLASSES}/convertibles/${convertibleClassId}`, payload, {
    headers: {
      'x-company-id': companyId.toString(),
    },
    validateStatus(status) {
      return true
    },
  })
}

export const getConvertibleSecurityClassById = (companyId: number, convertibleClassId: string) => {
  return axios.get(`${SECURITY_CLASSES}/convertibles/${convertibleClassId}`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status) {
      return true
    },
  })
}

export const exportConvertibleSecurityClasses = (companyId: number) => {
  return axios.get(`${SECURITY_CLASSES}/convertibles/csv/export`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status) {
      return true
    },
  })
}

export const getWarrantSecurityClasses = (
  companyId: number,
  page: number,
  pageSize: number,
  sortBy?: string,
  all?: string
) => {
  return axios.get(
    `${SECURITY_CLASSES}/warrants?page=${page}&pageSize=${pageSize}${
      sortBy ? `&sortBy=${sortBy}` : ''
    }${all ? `&all=${all}` : ''}`,
    {
      headers: {
        'x-company-id': companyId,
      },
      validateStatus(status) {
        return true
      },
    }
  )
}

export const deleteWarrantSecurityClass = (companyId: number, warrantClassId: string) => {
  return axios.delete(`${SECURITY_CLASSES}/warrants/${warrantClassId}`, {
    headers: {
      'x-company-id': companyId.toString(),
    },
    validateStatus(status) {
      return true
    },
  })
}

export const updateWarrantSecurityClass = (
  payload: any,
  companyId: number,
  warrantClassId: string
) => {
  return axios.post(`${SECURITY_CLASSES}/warrants/${warrantClassId}`, payload, {
    headers: {
      'x-company-id': companyId.toString(),
    },
    validateStatus(status) {
      return true
    },
  })
}

export const createWarrantSecurityClass = (payload: any, companyId: number) => {
  return axios.post(`${SECURITY_CLASSES}/warrants`, payload, {
    headers: {
      'x-company-id': companyId.toString(),
    },
    validateStatus(status) {
      return true
    },
  })
}

export const getWarrantSecurityClassById = (companyId: number, warrantClassId: string) => {
  return axios.get(`${SECURITY_CLASSES}/warrants/${warrantClassId}`, {
    headers: {
      'x-company-id': companyId,
    },
  })
}

export const exportWarrantSecurityClasses = (companyId: number) => {
  return axios.get(`${SECURITY_CLASSES}/warrants/csv/export`, {
    headers: {
      'x-company-id': companyId,
    },
  })
}

export const getShareTransactions = (
  shareholderId: string,
  companyId: number,
  page: number,
  pageSize: number,
  sortBy?: string,
  dateOfIssue?: string,
  all?: string
) => {
  return axios.get(
    `${SHAREHOLDER_TRANSACTIONS}/${shareholderId}/shares?page=${page}&pageSize=${pageSize}${
      sortBy ? `&sortBy=${sortBy}` : ''
    }${dateOfIssue ? `&dateOfIssue=${dateOfIssue}` : ''}${all ? `&all=${all}` : ''}`,
    {
      headers: {
        'x-company-id': companyId,
      },
    }
  )
}

export const createShareTransaction = (payload: any, companyId: number, shareholderId: string) => {
  return axios.post(`${SHAREHOLDER_TRANSACTIONS}/${shareholderId}/shares`, payload, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status) {
      return true
    },
  })
}

export const updateShareTransaction = (
  payload: any,
  companyId: number,
  shareTransactionId: string,
  shareholderId: string
) => {
  return axios.post(
    `${SHAREHOLDER_TRANSACTIONS}/${shareholderId}/shares/${shareTransactionId}`,
    payload,
    {
      headers: {
        'x-company-id': companyId.toString(),
      },
      validateStatus(status) {
        return true
      },
    }
  )
}

export const getShareTransactionById = (
  companyId: number,
  shareholderId: string,
  shareTransactionId: string
) => {
  return axios.get(`${SHAREHOLDER_TRANSACTIONS}/${shareholderId}/shares/${shareTransactionId}`, {
    headers: {
      'x-company-id': companyId,
    },
  })
}

export const exportShareTransactions = (companyId: number, shareholderId: string) => {
  return axios.get(`${SHAREHOLDER_TRANSACTIONS}/${shareholderId}/shares/csv/export`, {
    headers: {
      'x-company-id': companyId,
    },
  })
}

export const deleteShareTransaction = (
  companyId: number,
  shareTransactionId: string,
  shareholderId: string
) => {
  return axios.delete(`${SHAREHOLDER_TRANSACTIONS}/${shareholderId}/shares/${shareTransactionId}`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status) {
      return true
    },
  })
}

export const exportConvertibleTransactions = (companyId: number, shareholderId: string) => {
  return axios.get(`${SHAREHOLDER_TRANSACTIONS}/${shareholderId}/convertibles/csv/export`, {
    headers: {
      'x-company-id': companyId,
    },
  })
}

export const createConvertibleTransaction = (
  payload: any,
  companyId: number,
  shareholderId: string
) => {
  return axios.post(`${SHAREHOLDER_TRANSACTIONS}/${shareholderId}/convertibles`, payload, {
    headers: {
      'x-company-id': companyId.toString(),
    },
  })
}

export const updateConvertibleTransaction = (
  payload: any,
  companyId: number,
  convertibleTransactionId: string,
  shareholderId: string
) => {
  return axios.post(
    `${SHAREHOLDER_TRANSACTIONS}/${shareholderId}/convertibles/${convertibleTransactionId}`,
    payload,
    {
      headers: {
        'x-company-id': companyId.toString(),
      },
    }
  )
}

export const getConvertibleTransactionById = (
  companyId: number,
  shareholderId: string,
  convertibleTransactionId: string
) => {
  return axios.get(
    `${SHAREHOLDER_TRANSACTIONS}/${shareholderId}/convertibles/${convertibleTransactionId}`,
    {
      headers: {
        'x-company-id': companyId,
      },
    }
  )
}

export const deleteConvertibleTransaction = (
  companyId: number,
  convertibleTransactionId: string,
  shareholderId: string
) => {
  return axios.delete(
    `${SHAREHOLDER_TRANSACTIONS}/${shareholderId}/convertibles/${convertibleTransactionId}`,
    {
      headers: {
        'x-company-id': companyId,
      },
    }
  )
}

export const getConvertibleTransactions = (
  shareholderId: string,
  companyId: number,
  page: number,
  pageSize: number,
  sortBy?: string,
  dateOfIssue?: string
) => {
  return axios.get(
    `${SHAREHOLDER_TRANSACTIONS}/${shareholderId}/convertibles?page=${page}&pageSize=${pageSize}${
      sortBy ? `&sortBy=${sortBy}` : ''
    }${dateOfIssue ? `&dateOfIssue=${dateOfIssue}` : ''}`,
    {
      headers: {
        'x-company-id': companyId,
      },
    }
  )
}

export const getWarrantTransactions = (
  shareholderId: string,
  companyId: number,
  page: number,
  pageSize: number,
  sortBy?: string,
  dateOfIssue?: string
) => {
  return axios.get(
    `${SHAREHOLDER_TRANSACTIONS}/${shareholderId}/warrants?page=${page}&pageSize=${pageSize}${
      sortBy ? `&sortBy=${sortBy}` : ''
    }${dateOfIssue ? `&dateOfIssue=${dateOfIssue}` : ''}`,
    {
      headers: {
        'x-company-id': companyId,
      },
    }
  )
}

export const createWarrantTransaction = (
  payload: any,
  companyId: number,
  shareholderId: string
) => {
  return axios.post(`${SHAREHOLDER_TRANSACTIONS}/${shareholderId}/warrants`, payload, {
    headers: {
      'x-company-id': companyId.toString(),
    },
  })
}

export const updateWarrantTransaction = (
  payload: any,
  companyId: number,
  warrantTransactionId: string,
  shareholderId: string
) => {
  return axios.post(
    `${SHAREHOLDER_TRANSACTIONS}/${shareholderId}/warrants/${warrantTransactionId}`,
    payload,
    {
      headers: {
        'x-company-id': companyId.toString(),
      },
    }
  )
}

export const getWarrantTransactionById = (
  companyId: number,
  shareholderId: string,
  warrantTransactionId: string
) => {
  return axios.get(
    `${SHAREHOLDER_TRANSACTIONS}/${shareholderId}/warrants/${warrantTransactionId}`,
    {
      headers: {
        'x-company-id': companyId,
      },
    }
  )
}

export const deleteWarrantTransaction = (
  companyId: number,
  warrantTransactionId: string,
  shareholderId: string
) => {
  return axios.delete(
    `${SHAREHOLDER_TRANSACTIONS}/${shareholderId}/warrants/${warrantTransactionId}`,
    {
      headers: {
        'x-company-id': companyId,
      },
    }
  )
}

export const updateBuybackTransaction = (
  payload: any,
  companyId: number,
  buybackTransactionId: string,
  shareholderId: string
) => {
  return axios.post(
    `${SHAREHOLDER_TRANSACTIONS}/${shareholderId}/buybacks/${buybackTransactionId}`,
    payload,
    {
      headers: {
        'x-company-id': companyId.toString(),
      },
    }
  )
}

export const createBuybackTransaction = (
  payload: any,
  companyId: number,
  shareholderId: string
) => {
  return axios.post(`${SHAREHOLDER_TRANSACTIONS}/${shareholderId}/buybacks`, payload, {
    headers: {
      'x-company-id': companyId.toString(),
    },
  })
}

export const getBuybackTransactionById = (
  companyId: number,
  shareholderId: string,
  buybackTransactionId: string
) => {
  return axios.get(
    `${SHAREHOLDER_TRANSACTIONS}/${shareholderId}/buybacks/${buybackTransactionId}`,
    {
      headers: {
        'x-company-id': companyId,
      },
    }
  )
}

export const deleteBuybackTransaction = (
  companyId: number,
  buybackTransactionId: string,
  shareholderId: string
) => {
  return axios.delete(
    `${SHAREHOLDER_TRANSACTIONS}/${shareholderId}/buybacks/${buybackTransactionId}`,
    {
      headers: {
        'x-company-id': companyId,
      },
    }
  )
}

export const getBuybackTransactions = (
  shareholderId: string,
  companyId: number,
  page: number,
  pageSize: number,
  sortBy?: string,
  dateOfBuyback?: string
) => {
  return axios.get(
    `${SHAREHOLDER_TRANSACTIONS}/${shareholderId}/buybacks?page=${page}&pageSize=${pageSize}${
      sortBy ? `&sortBy=${sortBy}` : ''
    }${dateOfBuyback ? `&dateOfBuyback=${dateOfBuyback}` : ''}`,
    {
      headers: {
        'x-company-id': companyId,
      },
    }
  )
}

export const createTransferTransaction = (
  payload: any,
  companyId: number,
  shareholderId: string
) => {
  return axios.post(`${SHAREHOLDER_TRANSACTIONS}/${shareholderId}/transfers`, payload, {
    headers: {
      'x-company-id': companyId.toString(),
    },
  })
}

export const updateTransferTransaction = (
  payload: any,
  companyId: number,
  transferTransactionId: string,
  shareholderId: string
) => {
  return axios.post(
    `${SHAREHOLDER_TRANSACTIONS}/${shareholderId}/transfers/${transferTransactionId}`,
    payload,
    {
      headers: {
        'x-company-id': companyId.toString(),
      },
    }
  )
}

export const getTransferTransactionById = (
  companyId: number,
  shareholderId: string,
  transferTransactionId: string
) => {
  return axios.get(
    `${SHAREHOLDER_TRANSACTIONS}/${shareholderId}/transfers/${transferTransactionId}`,
    {
      headers: {
        'x-company-id': companyId,
      },
    }
  )
}

export const deleteTransferTransaction = (
  companyId: number,
  transferTransactionId: string,
  shareholderId: string
) => {
  return axios.delete(
    `${SHAREHOLDER_TRANSACTIONS}/${shareholderId}/transfers/${transferTransactionId}`,
    {
      headers: {
        'x-company-id': companyId,
      },
    }
  )
}

export const getTransferTransactions = (
  shareholderId: string,
  companyId: number,
  page: number,
  pageSize: number,
  sortBy?: string,
  transferDate?: string
) => {
  return axios.get(
    `${SHAREHOLDER_TRANSACTIONS}/${shareholderId}/transfers?page=${page}&pageSize=${pageSize}${
      sortBy ? `&sortBy=${sortBy}` : ''
    }${transferDate ? `&transferDate=${transferDate}` : ''}`,
    {
      headers: {
        'x-company-id': companyId,
      },
    }
  )
}

export const importShareholders = (data: any, companyId: number) => {
  return axios.post(
    `${GET_SHAREHOLDERS}/csv/import`,
    {shareholders: data},
    {
      headers: {
        'x-company-id': companyId.toString(),
      },
      validateStatus(status) {
        return true
      },
    }
  )
}

export const exportShareholders = (companyId: number) => {
  return axios.get(`${GET_SHAREHOLDERS}/csv/export`, {
    headers: {
      'x-company-id': companyId.toString(),
    },
    validateStatus(status) {
      return true
    },
  })
}

